import React from 'react';
import { Home, Users, UserPlus, User } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Componente BottomNav con navegación y animaciones
 */
export const BottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      id: 'home',
      label: 'Home',
      icon: <Home className="w-5 h-5" />,
      path: '/'
    },
    {
      id: 'equipo',
      label: 'Equipo',
      icon: <Users className="w-5 h-5" />,
      path: '/equipo'
    },
    {
      id: 'captacion',
      label: 'Captación',
      icon: <UserPlus className="w-5 h-5" />,
      path: '/captacion'
    },
    {
      id: 'perfil',
      label: 'Perfil',
      icon: <User className="w-5 h-5" />,
      path: '/perfil'
    }
  ];

  /**
   * Verifica si el item está activo según la ruta actual y sus subrutas
   */
  const isActive = (path: string): boolean => {
    // Caso especial para Home (solo ruta raíz)
    if (path === '/') {
      return location.pathname === '/';
    }
    
    // Configuración de rutas hijas para cada sección
    const subRoutes: Record<string, string[]> = {
      '/equipo': ['/tu-plantilla', '/asistencia', '/jornadas', '/estadisticas'],
      '/captacion': ['/disponibilidad', '/partidos', '/tus-informes'], // 'partidos' coincide con /partidos, /partidos-asignados etc
      '/perfil': ['/perfil'] 
    };

    // Verificar si es la ruta exacta
    if (location.pathname === path) return true;

    // Verificar si es una subruta definida
    const sectionRoutes = subRoutes[path] || [];
    if (sectionRoutes.some(route => location.pathname.startsWith(route))) {
      return true;
    }
    
    // Verificar por prefijo simple (fallback)
    return location.pathname.startsWith(path);
  };

  /**
   * Maneja la navegación con animación
   */
  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-secondary-800 border-t border-secondary-700 px-4 py-2 z-50">
      <div className="flex justify-around items-center">
        {navItems.map((item) => {
          const active = isActive(item.path);
          return (
            <button
              key={item.id}
              onClick={() => handleNavigation(item.path)}
              className={`
                flex flex-col items-center justify-center p-3 rounded-xl transition-all duration-300 ease-out
                transform active:scale-95 hover:scale-105
                ${active 
                  ? 'bg-primary-500/20 text-primary-500 shadow-lg shadow-primary-500/20' 
                  : 'text-secondary-400 hover:text-secondary-200 hover:bg-secondary-700/50'
                }
              `}
            >
              <div className={`
                transition-all duration-300 ease-out
                ${active ? 'transform -translate-y-0.5' : ''}
              `}>
                {item.icon}
              </div>
              <span className={`
                text-xs font-medium mt-1 transition-all duration-300
                ${active ? 'opacity-100' : 'opacity-70'}
              `}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;